import CaireHead from './CaireHead';

export default CaireHead;
